import { render } from "./CredencialSection.vue?vue&type=template&id=18a3b6c3&ts=true"
import script from "./CredencialSection.vue?vue&type=script&lang=ts"
export * from "./CredencialSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__